import { toBlob } from 'html-to-image';
interface screenshotProps {
  quality: number;
  pixelRatio: number;
}

const useScreenshot = ({ quality, pixelRatio }: screenshotProps) => {
  const takeInstagramScreenshot = (node: HTMLElement) => {
    if (!node) {
      throw new Error('You should provide correct html node.');
    }

    return toBlob(node).then(blob => {
      return toBlob(node).then(blob => {
        return toBlob(node, {
          quality: quality,
          pixelRatio: pixelRatio,
        }).then(blob => {
          return blob;
        });
      });
    });
  };

  return { takeInstagramScreenshot };
};

export { useScreenshot };
